﻿import {String} from "./Misc.js"
    export class KendoTreeviewTool {
        #seen: Set<string> = new Set<string>();
        #map: Map<string, kendo.data.Node> = new Map<string, kendo.data.Node>();
        #property: string | undefined;


        public Index = async (dataSource: kendo.data.HierarchicalDataSource, prop: string) => {

            if (String.IsNullOrEmpty(prop)) {
                throw new Error("prop doit avoir une valeur.");
            }

            const flat: Array<kendo.data.Node> = [];
            const root = dataSource.data() as any as kendo.data.Node[];
            const stack = root.slice();

            while (stack.length > 0) {
                const node = stack.pop();
                flat.push(node);
                if (!this.#seen.has(node.uid)) {
                    this.#seen.add(node.uid);
                    if (node.get(prop) != null)
                        this.#map.set(node.get(prop), node);
                }
                const children = typeof(node.children.data) == "function" ? (node.children.data() as any as kendo.data.Node[]) : [];
                if (children && children.length > 0) {
                    children.forEach(c => {
                        stack.push(c)
                    });
                }
            }
            
            return flat;
        }

        public Get = (key: string) => {
            return this.#map.get(key);
        }

        public Reset = () => {
            this.#seen.clear();
            this.#map.clear();
        }

        public get SizeOfMap() {
            return this.#map.size;
        }
        
        public Iterate = () => {
            this.#map.forEach((x, y) => { console.log(y)});
        }

    }
